import { render, staticRenderFns } from "./ApplicationOverviewTemplate.vue?vue&type=template&id=4bf9c0b5&"
import script from "./ApplicationOverviewTemplate.vue?vue&type=script&lang=ts&"
export * from "./ApplicationOverviewTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports